// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceInfo_root__kh1_Q","root_right":"PriceInfo_root_right__vrDz5"};